export const DEV_MODULE_CACHE_BUSTER = 0;

export const DEV_MODULE_DIR = `~dev-module`;
